import { render, staticRenderFns } from "./AIWritingActivityDrawerComp.vue?vue&type=template&id=4a1d559a&scoped=true"
import script from "./AIWritingActivityDrawerComp.vue?vue&type=script&lang=js"
export * from "./AIWritingActivityDrawerComp.vue?vue&type=script&lang=js"
import style0 from "./AIWritingActivityDrawerComp.vue?vue&type=style&index=0&id=4a1d559a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d559a",
  null
  
)

export default component.exports